"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEnhancements = instanceOfEnhancements;
exports.EnhancementsFromJSON = EnhancementsFromJSON;
exports.EnhancementsFromJSONTyped = EnhancementsFromJSONTyped;
exports.EnhancementsToJSON = EnhancementsToJSON;
exports.EnhancementsToJSONTyped = EnhancementsToJSONTyped;
/**
 * Check if a given object implements the Enhancements interface.
 */
function instanceOfEnhancements(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('price' in value) || value['price'] === undefined)
        return false;
    return true;
}
function EnhancementsFromJSON(json) {
    return EnhancementsFromJSONTyped(json, false);
}
function EnhancementsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'price': json['price'],
    };
}
function EnhancementsToJSON(json) {
    return EnhancementsToJSONTyped(json, false);
}
function EnhancementsToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'price': value['price'],
    };
}
